import clsx from 'clsx';
import { Upload } from '@src/components/ui';
import { ICommonFormProps } from '../../DynamicForm.types';
import { useEffect, useState } from 'react';

export function FormUpload(props: Readonly<ICommonFormProps>) {
    const { label, keyName, helper, setValue } = props;
    const [fileSrc, setFileSrc] = useState<string | undefined>(
        props.field?.value
    );

    useEffect(() => {
        setFileSrc(props.field?.value);
    }, [props.field?.value]);

    const handeRemove = () => {
        setFileSrc(undefined);
        if (setValue && keyName) {
            setValue(keyName, undefined, { shouldDirty: true });
            props.field?.onChange('');
        }
    };
    return (
        <div
            className={clsx(
                'flex flex-col items-start justify-center rounded-lg',
                props.formProps?.classNames
            )}
        >
            <div
                className={clsx(
                    'flex flex-col sm:flex-row sm:space-x-2 items-center justify-center cursor-pointer',
                    props.formProps?.buttonsWrapperClassName
                )}
            >
                <Upload
                    callBack={(info) => {
                        const src = info.file.response?.data.path;
                        props.field?.onChange(src);
                        setFileSrc(src);
                    }}
                    onRemove={handeRemove}
                    format={props.formProps?.accept ?? ''}
                    uploadPath={props.formProps?.uploadPath}
                    error={!!props.errors}
                    label={label}
                    maxCount={props.formProps?.maxCount}
                    beforeUpload={props.formProps?.beforeUpload}
                    errorKey={props.formProps?.errorKey}
                    errorClassName={props.formProps?.errorClassName}
                    src={fileSrc}
                    name={props.keyName}
                    size={props.formProps?.size}
                    helper={helper}
                />
            </div>
        </div>
    );
}
